import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { showSnackbar } from "../../actions/snackbarActions";
import { closeSnackbar } from "../../actions/snackbarActions";
import { withStyles } from '@material-ui/core/styles';
import compose from 'recompose/compose';
import { connect } from "react-redux";

const styles = theme => ({
   root: {
     flexGrow: 1,
     padding: 8,
     margin: 8
   },
   progress: {
     margin: theme.spacing.unit * 2,
   },
 });

class SnackbarMessage extends React.Component {
   render() {
     return (
       <Snackbar
         open={this.props.snackbarVisible}
         message={this.props.snackbarMessage}
         onClose={this.props.closeSnackbar}
         autoHideDuration={(this.props.autoHideDuration) ? this.props.autoHideDuration : 3000 }
         {...this.props.snackbar}
       />
     );
   }
 }

 function mapStateToProps(state) {
   return {
     snackbarMessage: state.snackbar.snackbar.snackbarMsg,
     snackbarVisible: state.snackbar.snackbar.snackbarVisible
   };
 }
 
 function mapDispatchToProps(dispatch) {
   return {
      showSnackbar: () => {
        dispatch(showSnackbar())
      },
      closeSnackbar: () => {
         dispatch(closeSnackbar())
      }
    }
 }

 export default
 compose(
   withStyles(styles),
   connect(mapStateToProps, mapDispatchToProps)
 )(SnackbarMessage);


// WEBPACK FOOTER //
// ./src/components/Layout/SnackbarMessage.js